import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const approveStorePr = createAsyncThunk('/approveStorePr/pro-store-approve-pr',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-store-approve-pr`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                }
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data?.message || "Failed to process PR");
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error?.response?.data?.message || "Something went wrong");
            return error;
        }
    });

const approveStorePrSlice = createSlice({
    name: "approveStorePr",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(approveStorePr.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(approveStorePr.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(approveStorePr.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default approveStorePrSlice.reducer;
